import React, { useState, useEffect } from 'react';
import { usePermissions } from 'store/redux/apis/workspace/permissions.api';
import { snackbar } from 'components/notifications/notifications';
import { Popconfirm, Switch } from 'antd';
import { useChangeAdsetStatusMutation } from 'store/redux/states/ad_adset/ad_adset.api';
import { useChangeCampaignStatusMutation } from 'store/redux/states/ad_campaign/ad_campaign.api';
import { useChangeAdStatusMutation } from 'store/redux/states/ad_ad/ad_ad.api';

const AdProcessFormatter = ({ row, level = 'adset' }) => {
  const [checked, setChecked] = useState();
  const [loading, setLoading] = useState(false);
  const { canEdit } = usePermissions();

  const [changeAdsetStatus] = useChangeAdsetStatusMutation();
  const [changeCampaignStatus] = useChangeCampaignStatusMutation();

  useEffect(() => {
    setChecked(row?.status === 'active');
  }, [row]);

  const changeStatus = async (service, active) => {
    setLoading(true);
    try {
      setChecked(active);
      const result = await service({
        id: row.id,
        status: active ? 'active' : 'paused',
      });

      if (result?.error) {
        throw new Error(result.error?.data?.message || 'Unknown error');
      }

      snackbar.success('Status successfully changed.');
    } catch (error) {
      setChecked(!active);
      snackbar.error(`Failed to change status: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleAdStatusChange = (active) => {
    if (!canEdit('reporting')) return;

    if (level === 'adset') {
      changeStatus(changeAdsetStatus, active);
    } else if (level === 'campaign') {
      changeStatus(changeCampaignStatus, active);
    } else if (level === 'ad') {
      changeStatus(useChangeAdStatusMutation, active);
    }
  };

  return (
    <div className='flex items-center justify-between h-full gap-2' key={row.id}>
      <Popconfirm
        title={`Are you sure you want to turn ${checked ? 'off' : 'on'} this ${level}?`}
        onConfirm={() => handleAdStatusChange(!checked)}
        okText='Yes'
        cancelText='No'
        disabled={!canEdit('reporting')}
      >
        <Switch key={row.id} loading={loading} size='small' checked={checked} />
      </Popconfirm>
    </div>
  );
};

export default AdProcessFormatter;
